<section>
  <div>
    <div class="inner-wrap">
      <p class="text-center">
        <img src="assets/modules/dummy-assets/common/img/GovEVA.png" alt="DigiCompany">
      </p>
      <h2>Reset Password</h2>
      <form autocomplete="off" [formGroup]="resetPasswordForm">
        <div class="form-group">
          <label>Password:</label>
          <div class="password-wrapper">
            <input
              [type]="passwordVisible ? 'text' : 'password'"
              class="form-control"
              placeholder="Password"
              formControlName="password"
              (keyup)="RemoveSavePassword1()">
            <i class="fa" [ngClass]="passwordVisible ? 'fa-eye' : 'fa-eye-slash'" (click)="togglePasswordVisibility('new')" (keydown.enter)="togglePasswordVisibility('new')" (keydown.space)="togglePasswordVisibility('new'); $event.preventDefault()" tabindex="0" role="button"></i>
          </div>
          <div *ngIf="resetPasswordForm.controls['password'].hasError('pattern') && resetPasswordForm.controls['password'].touched" class="form-control-error-custom">
            <ul>
              <li>Please enter a minimum of 8 characters.</li>
              <li>At least one lowercase and one uppercase letter.</li>
              <li>At least one number.</li>
              <li>At least one special character.</li>
            </ul>
          </div>
          <div *ngIf="resetPasswordForm.controls['password'].hasError('required') && resetPasswordForm.controls['password'].touched" class="form-control-error-custom">
            Password is required.
          </div>
        </div>
        <div class="form-group">
          <label>Re-enter Password:</label>
          <div class="password-wrapper">
            <input
              [type]="rePasswordVisible ? 'text' : 'password'"
              class="form-control"
              placeholder="Re-enter Password"
              formControlName="confirmPassword"
              (keyup)="RemoveSavePassword()">
            <i class="fa" [ngClass]="rePasswordVisible ? 'fa-eye' : 'fa-eye-slash'" (click)="togglePasswordVisibility('re')" (keydown.enter)="togglePasswordVisibility('re')" (keydown.space)="togglePasswordVisibility('re'); $event.preventDefault()" tabindex="0" role="button"></i>
          </div>
          <div *ngIf="resetPasswordForm.get('password').touched && resetPasswordForm.get('confirmPassword').touched && resetPasswordForm.get('password').value !== resetPasswordForm.get('confirmPassword').value" class="form-control-error-custom">
            Passwords entered do not match.
          </div>
          <div *ngIf="resetPasswordForm.controls['confirmPassword'].hasError('required') && resetPasswordForm.controls['confirmPassword'].touched" class="form-control-error-custom">
            Please confirm your password.
          </div>
        </div>
        <div class="text-center">
          <button class="btn btn-primary btn-block mr-2 mb-2" style="margin-top: 10px;" 
            [disabled]="!resetPasswordForm.valid"
            (click)="submitPassword()">
            <i aria-hidden="true"></i>Reset Password
          </button>
        </div>
      </form>
    </div>
  </div>
</section>
